import { createSlice } from '@reduxjs/toolkit';

export const servicesIaSlice = createSlice({
  name: 'servicesIa',
  initialState: {
    service_ia_list: [],
    service_ia: {},
  },
  reducers: {
    setServicesIaListRedux: (state, { payload }) => {
      state.service_ia_list = payload;
    },
    setServiceIaRedux: (state, { payload }) => {
      state.service_ia = payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setServicesIaListRedux, setServiceIaRedux } = servicesIaSlice.actions;
